module.exports = __webpack_public_path__ + "img/520.cbb7d0c7.png";